import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  emptyGlobalAuthor,
  type FirestoreGlobalAuthor,
} from '../firestore/GlobalAuthor/schema'
import type { FirebaseRepository } from './FirebaseRepository'

export class GlobalAuthor extends ObservableModelWithDecorators<FirestoreGlobalAuthor> {
  static empty(repository: FirebaseRepository, id?: string) {
    return emptyModel(repository, this, emptyGlobalAuthor, id)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, emptyGlobalAuthor)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreGlobalAuthor>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
